module.exports = __webpack_public_path__ + "img/theme.7779cbac.svg";